import { client } from ".";

export const fetchReviews = async ({
  astrologerId,
  featured,
  rating,
  order,
  searchTerm,
  page,
  limit,
}) => {
  try {
    let api = `/api/reviews/astrologer/${astrologerId}?page=${page}&limit=${limit}`;
    if (rating) {
      console.log("rating:", rating);
      api += `&rating=${rating}`;
    }
    if (featured) {
      api += `&featured=true`;
    }
    if (order.entity) {
      api += `&sortBy=${order.entity}&order=${order.sortBy}`;
    }
    if (searchTerm) {
      api += `&search=${searchTerm}`;
    }
    // console.log(api);
    const { data, status } = await client.get(api);
    // console.log(data);
    return { status, data };
  } catch (err) {
    throw new Error(`Unable to fetch reviews: ${err}`);
  }
};
